function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import every from 'lodash/every';
import some from 'lodash/some';
import { AppContext } from 'context';
import history from 'helpers/history';
import App from 'modules/App';
import Account, { LogoutBtn } from 'modules/Account';
import CloudDrive from 'modules/CloudDrive';
import PatientProfile from './PatientProfile';
var _React_PureComponent;
class PatientSetup extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        if (!this.isCentralStorageSet) {
            this.props.onAuthorizeCloudDrive();
        }
    }
    get isCentralStorageSet() {
        return every([
            'RefreshToken',
            'ReferenceKey',
            'StorageAccount'
        ], (key)=>some(this.props.walletEntriesList, {
                serviceName: 'CentralStorage',
                key
            }));
    }
    renderStep() {
        const { enrollCode, invitationCode } = this.props;
        return /*#__PURE__*/ _jsx(PatientProfile, {
            enrollCode: enrollCode,
            invitationCode: invitationCode,
            isCentralStorageSet: this.isCentralStorageSet
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(LogoutBtn, {}),
                this.renderStep()
            ]
        });
    }
    constructor(props, context){
        super(props);
        if (props.patientProfile && props.patientProfile.encryptedExchangeToken) {
            history.push(context.getUrl('my-results'));
        }
    }
}
_define_property(PatientSetup, "contextType", AppContext);
_define_property(PatientSetup, "propTypes", {
    // Explicit props
    enrollCode: PropTypes.string,
    invitationCode: PropTypes.string,
    // Implicit props
    patientProfile: PropTypes.shape({
        encryptedExchangeToken: PropTypes.string
    }),
    countrySettings: PropTypes.shape({
        isCentralStorageFixed: PropTypes.bool
    }),
    walletEntriesList: PropTypes.arrayOf(PropTypes.shape({
        serviceName: PropTypes.string,
        key: PropTypes.string
    })),
    // Implicit actions
    onAuthorizeCloudDrive: PropTypes.func
});
const mapStateToProps = (state)=>({
        patientProfile: Account.selectors.patientProfile(state),
        countrySettings: App.selectors.countrySettings(state),
        walletEntriesList: Account.selectors.walletEntriesList(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onAuthorizeCloudDrive: ()=>dispatch(CloudDrive.actions.authorize('CentralStorage', 'pwd'))
    });
const ConnectedPatientSetup = connect(mapStateToProps, mapDispatchToProps)(PatientSetup);
export default ConnectedPatientSetup;
